import React, { useEffect, useState } from "react";
import { sendGetReq } from "../DAL/http";                            

const Home = () => {
  const [data, setdata] = useState({})
  useEffect(() => {
    debugger
    sendGetReq("dashboard")
      .then((response) => {
        debugger
        setdata((response));
        console.log(response)
      })
      .catch((error) => {
        console.error("Error getting all Users:", error);
      });
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-xl-4 col-sm-6 grid-margin stretch-card">
          <div className="card bg-gradient-primary gradient-card">
            <div className="card-body">
              <div className="row">
                <div className="col-9">
                  <div className="d-flex align-items-center align-self-start">
                    <h3 className="mb-0 text-white " style={{fontSize:"20px"}}>{data?.applicantsCount}</h3>
                  </div>
                </div>
                {/* <div className="col-3 mt-3">
                  <div className="sidebar-item">
                  <span>
        <i className="ti ti-file-description text-white " style={{backgroundColor:"transparent",fontSize:"40px",alignSelf:"center"}} />
      </span>
                  </div>
                </div> */}
              </div>
              <h6 className="text-muted font-weight-normal text-white " style={{fontSize:"15px"}}>Applications</h6>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-sm-6 grid-margin stretch-card">
          <div className="card bg-gradient-primary gradient-card">
            <div className="card-body">
              <div className="row">
                <div className="col-9">
                  <div className="d-flex align-items-center align-self-start">
                    <h3 className="mb-0 text-white " style={{fontSize:"20px"}}>{data?.jobsCount}</h3>
                  </div>
                </div>
                <div className="col-3">
                  <div className="icon icon-box-success">
                    <span className="mdi mdi-arrow-top-right icon-item" />
                  </div>
                </div>
              </div>
              <h6 className="text-muted font-weight-bold text-white " style={{fontSize:"15px"}}>Jobs</h6>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-sm-6 grid-margin stretch-card">
          <div className="card bg-gradient-primary gradient-card">
            <div className="card-body">
              <div className="row">
                <div className="col-9">
                  <div className="d-flex align-items-center align-self-start">
                    <h3 className="mb-0 text-white " style={{fontSize:"20px"}}>{data?.contactsCount}</h3>
                  </div>
                </div>
                <div className="col-3">
                  <div className="icon icon-box-success">
                    <span className="mdi mdi-arrow-top-right icon-item" />
                  </div>
                </div>
              </div>
              <h6 className="text-muted font-weight-bold text-white " style={{fontSize:"15px"}}>Contacts</h6>
            </div>
          </div>
        </div>
       
       
      </div>
    </>
  );
};

export default Home;
